"use client";

import { c as _c } from "react/compiler-runtime";
import { getCoingeckoChainInfo } from "../../../shared/constants/chains/supported.js";
import { useSearchParams } from "../../../shared/react/hooks/index.js";
import { useQuery } from "@tanstack/react-query";
async function fetchTokenInfo(network, address) {
  const response = await fetch("https://api.b3.fun/tokens", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Service-Method": "getCoinGeckoTokenInfo"
    },
    body: JSON.stringify({
      network,
      address
    })
  });
  if (!response.ok) {
    throw new Error("Failed to fetch token info");
  }
  return response.json();
}
/**
 * Hook to parse token data from URL parameters and fetch additional token info.
 * Looks for parameters: [prefix]Currency
 */
export function useTokenFromUrl(t0) {
  const $ = _c(34);
  const {
    defaultToken,
    prefix
  } = t0;
  const searchParams = useSearchParams();
  let chainIdParam;
  let currencyParam;
  let network;
  let t1;
  let t2;
  if ($[0] !== defaultToken || $[1] !== prefix || $[2] !== searchParams) {
    currencyParam = searchParams.get(`${prefix}Currency`);
    let t3;
    if ($[8] !== prefix || $[9] !== searchParams) {
      t3 = searchParams.get(`${prefix}ChainId`);
      $[8] = prefix;
      $[9] = searchParams;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    chainIdParam = t3;
    let t4;
    if ($[11] !== chainIdParam) {
      t4 = chainIdParam ? getCoingeckoChainInfo(Number(chainIdParam)) : null;
      $[11] = chainIdParam;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    const chainInfo = t4;
    network = chainInfo?.coingecko_id || "";
    t1 = Boolean;
    t2 = currencyParam && chainIdParam && chainInfo && currencyParam.toLowerCase() !== defaultToken.address.toLowerCase();
    $[0] = defaultToken;
    $[1] = prefix;
    $[2] = searchParams;
    $[3] = chainIdParam;
    $[4] = currencyParam;
    $[5] = network;
    $[6] = t1;
    $[7] = t2;
  } else {
    chainIdParam = $[3];
    currencyParam = $[4];
    network = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  const shouldFetchToken = t1(t2);
  let t3;
  let t4;
  if ($[13] !== currencyParam || $[14] !== network) {
    t3 = ["tokenInfo", network, currencyParam];
    t4 = () => fetchTokenInfo(network, currencyParam || "");
    $[13] = currencyParam;
    $[14] = network;
    $[15] = t3;
    $[16] = t4;
  } else {
    t3 = $[15];
    t4 = $[16];
  }
  let t5;
  if ($[17] !== shouldFetchToken || $[18] !== t3 || $[19] !== t4) {
    t5 = {
      queryKey: t3,
      queryFn: t4,
      enabled: shouldFetchToken,
      staleTime: Infinity,
      gcTime: Infinity
    };
    $[17] = shouldFetchToken;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const {
    data: tokenInfo,
    isError
  } = useQuery(t5);
  if (!shouldFetchToken) {
    return defaultToken;
  }
  if (isError || !tokenInfo) {
    const t6 = currencyParam || "";
    const t7 = Number(chainIdParam);
    let t8;
    if ($[21] !== defaultToken || $[22] !== t6 || $[23] !== t7) {
      t8 = {
        ...defaultToken,
        address: t6,
        chainId: t7
      };
      $[21] = defaultToken;
      $[22] = t6;
      $[23] = t7;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    return t8;
  }
  const t6 = tokenInfo.data.attributes.address;
  const t7 = Number(chainIdParam);
  let t8;
  if ($[25] !== tokenInfo.data.attributes.image_url) {
    t8 = {
      logoURI: tokenInfo.data.attributes.image_url
    };
    $[25] = tokenInfo.data.attributes.image_url;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== t7 || $[28] !== t8 || $[29] !== tokenInfo.data.attributes.address || $[30] !== tokenInfo.data.attributes.decimals || $[31] !== tokenInfo.data.attributes.name || $[32] !== tokenInfo.data.attributes.symbol) {
    t9 = {
      address: t6,
      chainId: t7,
      name: tokenInfo.data.attributes.name,
      symbol: tokenInfo.data.attributes.symbol,
      decimals: tokenInfo.data.attributes.decimals,
      metadata: t8
    };
    $[27] = t7;
    $[28] = t8;
    $[29] = tokenInfo.data.attributes.address;
    $[30] = tokenInfo.data.attributes.decimals;
    $[31] = tokenInfo.data.attributes.name;
    $[32] = tokenInfo.data.attributes.symbol;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  return t9;
}
export function useTokenFromAddress(t0) {
  const $ = _c(17);
  const {
    address,
    chainId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== address || $[1] !== chainId) {
    t1 = ["tokenInfo", address, chainId];
    t2 = () => fetchTokenInfo(getCoingeckoChainInfo(chainId).coingecko_id, address);
    $[0] = address;
    $[1] = chainId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  const t3 = Boolean(address);
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3,
      staleTime: Infinity,
      gcTime: Infinity
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data: tokenInfo,
    isError
  } = useQuery(t4);
  if (isError || !tokenInfo) {
    return;
  }
  const t5 = tokenInfo?.data.attributes.name || "";
  const t6 = tokenInfo?.data.attributes.symbol || "";
  const t7 = tokenInfo?.data.attributes.decimals || 18;
  const t8 = tokenInfo?.data.attributes.image_url;
  let t9;
  if ($[8] !== t8) {
    t9 = {
      logoURI: t8
    };
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== address || $[11] !== chainId || $[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t9) {
    t10 = {
      address,
      chainId,
      name: t5,
      symbol: t6,
      decimals: t7,
      metadata: t9
    };
    $[10] = address;
    $[11] = chainId;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}